module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiCnIt.15e9714.eot";